import React from 'react';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Select } from 'antd';
import { FieldArray, useFormikContext } from 'formik';

import { InputLimitWidth } from 'components/Layout/Form';
import { FlexContainer } from 'components/Layout/common';
import { TRuleCreatePage } from 'containers/Rule/i18n/TModules';
import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';

const AgeGroup: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>();

  const { t } = useMultiLanguageTranslation();

  return (
    <>
      <FieldArray name="filters.age">
        {({ push, remove }) => (
          <>
            {values?.filters?.age
              .map((ageGroup, index) => (
                <FlexContainer key={index} center margin="0 0 5px">
                  <InputLimitWidth>
                    <Select
                      value={values?.filters?.age?.[index]?.criteria?.policy}
                      onSelect={value =>
                        setFieldValue(`filters.age[${index}].criteria.policy`, value)
                      }
                      placeholder={t(
                        `${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.AgeFilter.Includes`
                      )}
                      data-testid="age-include-select"
                    >
                      <Select.Option value="include" data-testid="age-include-select-include">
                        {t(`${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.AgeFilter.Includes`)}
                      </Select.Option>
                      <Select.Option value="exclude" data-testid="age-include-select-exclude">
                        {t(`${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.AgeFilter.Excludes`)}
                      </Select.Option>
                    </Select>
                  </InputLimitWidth>
                  {t(`${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.AgeFilter.From`)}
                  &nbsp;&nbsp;
                  <InputLimitWidth width="80">
                    <Select
                      onChange={value =>
                        setFieldValue(`filters.age[${index}].criteria.gteq`, value)
                      }
                      value={values?.filters?.age?.[index]?.criteria?.gteq}
                      data-testid="from-age-select"
                      placeholder={t(
                        `${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.AgeFilter.FromPlaceholder`
                      )}
                    >
                      {Array.from(Array(100).keys())
                        .map(i => i + 1)
                        .map((age, index) => {
                          return (
                            <Select.Option
                              key={index}
                              value={age}
                              data-testid={`from-age-select__${age}`}
                            >
                              {age}
                            </Select.Option>
                          );
                        })}
                    </Select>
                  </InputLimitWidth>
                  {t(`${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.AgeFilter.To`)}&nbsp;&nbsp;
                  <InputLimitWidth width="80">
                    <Select
                      onChange={value =>
                        setFieldValue(`filters.age[${index}].criteria.lteq`, value)
                      }
                      value={values?.filters?.age?.[index]?.criteria?.lteq}
                      data-testid="to-age-select"
                      placeholder={t(
                        `${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.AgeFilter.ToPlaceholder`
                      )}
                    >
                      {Array.from(Array(100).keys())
                        .map(i => i + 1)
                        .map((age, index) => {
                          return (
                            <Select.Option
                              key={index}
                              value={age}
                              data-testid={`to-age-select__${age}`}
                            >
                              {age}
                            </Select.Option>
                          );
                        })}
                    </Select>
                  </InputLimitWidth>
                  <DeleteOutlined onClick={() => remove(index)} style={{ color: '#ff4d4f' }} />
                </FlexContainer>
              ))
              .reduce((acc, item, index) => {
                return acc === null
                  ? [item]
                  : [...acc, <strong key={`separator-${index}`}>and</strong>, item];
              }, null)}
            <Button
              icon={<PlusOutlined />}
              onClick={() =>
                push({
                  type: 'age',
                  criteria: {
                    gteq: '',
                    lteq: '',
                    policy: 'include'
                  }
                })
              }
            >
              {t(`${TRuleCreatePage}.LoyaltyAudience.AudienceFilters.AgeFilter.AddRange`)}
            </Button>
          </>
        )}
      </FieldArray>
    </>
  );
};

export default AgeGroup;
